<?xml version="1.0" encoding="UTF-8"?>
<svg width="11px" height="16px" viewBox="0 0 11 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-7" fill="#FA6A95">
            <rect id="Rectangle" x="0" y="0" width="4" height="16" rx="1"></rect>
            <rect id="Rectangle" x="7" y="0" width="4" height="16" rx="1"></rect>
        </g>
    </g>
</svg>